import React from 'react';
import { Main } from './components';

const Tracking = () => <Main />;

export default Tracking;

